var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorDivStyle"},[_c('img',{attrs:{"src":require("../../assets/errormark.png")}}),_c('span',{style:([_vm.errorHeadingColour && { color: _vm.errorHeadingColour }])},[_vm._v(_vm._s(_vm.errorMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }